import ApiRequest from "../util/ApiRequest";

export default class SessionDAO {

    static inviteToSession = async (sessionId, users, templateEmail) => {
        return await ApiRequest.set(`/another/emergency/endpoint/invite/${sessionId}/${templateEmail}`, "POST",users);
    }

}
